module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_copy_down-9a4ffd836c709958eff80a3260f8a1cb.png";